export const COMPOSER_ROUTES: { [index: number]: string } = {
  1: 'plans',
  2: 'product',
  3: 'campaign',
  4: 'root', // Convert "root" to "/"
  5: 'deals',
  6: 'answers',
  7: 'podcasts',
  8: 'notes',
  9: 'schoolData',
};
